module.exports = __webpack_public_path__ + "img/P1070890.d8cba595.jpg";